import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Watch, Prop, Mixins } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
// SYSTEM-1
import { IEngagementActivity } from "@/store/models/engagements/engagementActivity";
import EngagementsModule from "@/store/modules/engagements.module";
import BaseMixer from "../../BaseMixer";
import { EngagementActivityActionModel } from "@/store/models/engagements/engagementActivityAction";
import { toaster } from "@/utilities/toaster";
import DeleteComponent from "@/components/deleteComponent.vue";
let StageActivityActions = /** @class */ (() => {
    var _a;
    let StageActivityActions = class StageActivityActions extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.showActionItem = false;
            this.showActionHint = false;
            this.isEditing = false;
            this.showDeleteAction = false;
            this.engagementActivityAction = new EngagementActivityActionModel();
        }
        showActionText() {
            this.engagementActivityAction = new EngagementActivityActionModel();
            this.showActionItem = true;
        }
        saveAction(activity) {
            this.validate("engagementActivityActionObserver").then((response) => {
                if (response) {
                    this.engagementActivityAction.id = uuidv4();
                    this.engagementActivityAction.activityId = activity.activityId;
                    EngagementsModule.SaveActivityAction(this.engagementActivityAction).then((response) => {
                        this.showActionItem = false;
                        this.isEditing = false;
                        this.engagementActivityAction = new EngagementActivityActionModel();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        cancelAction(activity) {
            this.showActionItem = false;
            this.showActionHint = false;
            this.isEditing = false;
            this.engagementActivityAction = new EngagementActivityActionModel();
        }
        deleteAction(action) {
            this.engagementActivityAction = action;
            this.showDeleteAction = true;
        }
        deletingAction() {
            EngagementsModule.DeleteTenantEnagagementActivityAction(this.engagementActivityAction).then((response) => {
                this.showDeleteAction = false;
                toaster.ShowApiSuccess(response);
                this.engagementActivityAction = new EngagementActivityActionModel();
            });
        }
        get hasActionItems() {
            return this.model.actions.length > 0;
        }
        isActionValueChanged() {
            if (this.engagementActivityAction.action.length > 0) {
                this.showActionHint = true;
            }
            else {
                this.showActionHint = false;
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IEngagementActivity !== "undefined" && IEngagementActivity) === "function" ? _a : Object)
    ], StageActivityActions.prototype, "model", void 0);
    __decorate([
        Watch("engagementActivityAction", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StageActivityActions.prototype, "isActionValueChanged", null);
    StageActivityActions = __decorate([
        Component({
            name: "StageActivityActions",
            components: {
                DeleteComponent,
            },
        })
    ], StageActivityActions);
    return StageActivityActions;
})();
export default StageActivityActions;
